'use strict';

angular.module('AcaApp').factory('SendService',
[
  'PrintResource',
  'XmitResource',
  'XmitToStateResource',

  function(PrintResource, XmitResource, XmitToStateResource){
    return{
      runBatchPrint: function(printRequest){
        var rpcConfig = {method: 'RunBatchPrint', params: [printRequest]};
        return PrintResource.executeRpc(rpcConfig).$promise;
      },
      runBatchPrintLrj: function(printRequest){
        var rpcConfig = {method: 'RunBatchPrintLrj', params: [printRequest]};
        return PrintResource.executeRpc(rpcConfig).$promise;
      },
      generateXmit: function(transmittalRequest){
        var rpcConfig = {method: 'GenerateXmit', params: [transmittalRequest]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      generateStateXmit: function(stateTransmittalRequest){
        var rpcConfig = {method: 'sendStateXmit', params: [stateTransmittalRequest]};
        return XmitToStateResource.executeRpc(rpcConfig).$promise;
      },
      generateDocgenFederalXmit: function(transmittalRequest){
        var rpcConfig = {method: 'GenerateDocgenXmit', params: [transmittalRequest]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      isThereAnyIncompleteRecord: function(stateTransmittalRequest){
        var rpcConfig = {method: 'isThereAnyIncompleteRecord', params: [stateTransmittalRequest]};
        return XmitToStateResource.executeRpc(rpcConfig).$promise;
      },
      isThereAnyOrphanRecord: function(stateTransmittalRequest){
        var rpcConfig = {method: 'isThereAnyOrphanRecord', params: [stateTransmittalRequest]};
        return XmitToStateResource.executeRpc(rpcConfig).$promise;
      },
      markAsTransmitted: function(id, metaInfo){
        var rpcConfig = {method: 'markAsTransmitted', params: [id, metaInfo]};
        return XmitToStateResource.executeRpc(rpcConfig).$promise;
      },
      sendStateXmit: function(requestStateXmit){
        var rpcConfig = {method: 'SubmitFileToState', params: [requestStateXmit]};
        return XmitToStateResource.executeRpc(rpcConfig).$promise;
      },
      cancelStateTransmittal: function(xmitRun, filesNames, metaInfo){
        var rpcConfig = {method: 'cancelStateTransmittal', params: [xmitRun, filesNames, metaInfo]};
        return XmitToStateResource.executeRpc(rpcConfig).$promise;
      },
      cancelFederalTransmittal: function(fileNames, cancelXmitRequest){
        var rpcConfig = {method: 'cancelFederalTransmittal', params: [fileNames, cancelXmitRequest]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      autoPopulateBox20: function(transmittalRequest){
        var rpcConfig = {method: 'AutoPopulateBox20', params: [transmittalRequest]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      callXmit: function(transmittalRequest){
        var rpcConfig = {method: 'CallXmit', params: [transmittalRequest]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      GetMultipleSubscribersExistence: function(){
        var rpcConfig = {method: 'CheckMultipleSubscribersExistence', params: []};
        return PrintResource.executeRpc(rpcConfig).$promise;
      },
      GetUncoveredIndividuals: function(){
        var rpcConfig = {method: 'GenerateUncoveredIndividualsReport', params: []};
        return PrintResource.executeRpc(rpcConfig).$promise;
      },
      CancelXmit: function(canceXmirRequest){
        var rpcConfig = {method: 'CancelXmit', params: [canceXmirRequest]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      SendXmit: function(xmitRequest){
        var rpcConfig = {method: 'SendXmit', params: [xmitRequest]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      GetTransmittalStatusList: function(){
        var rpcConfig = {method: 'GetTransmittalStatusList', params: []};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      GetEmployerInfoInTransmittal: function(xmitRequest){
        var rpcConfig = {method: 'GetEmployerInfoInTransmittal', params: [xmitRequest]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      AreThereTransmittalsNotSubmitted: function(){
        var rpcConfig = {method: 'AreThereTransmittalsNotSubmitted', params: []};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      AreThereTransmittalsInProgres: function(){
        var rpcConfig = {method: 'AreThereTransmittalsInProgres', params: []};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      saveNps: function(request){
        var rpcConfig = {method: 'SaveNps', params: [request]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      getIrsErrorReports: function(){
        var rpcConfig = {method: 'GetIrsErrorReports', params: []};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      getIrsErrorReportsCount: function(){
        var rpcConfig = {method: 'GetIrsErrorReportsCount', params: []};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      reportErrorByXmit: function(xmit){
        var rpcConfig = {method: 'ReportErrorByXmit', params: [xmit]};
        return XmitResource.executeRpc(rpcConfig).$promise;
      },
      getPrintDetailByStmtRun: function(stmtRun, fchar){
        var rpcConfig = {method: 'GetPrintDetailByStmtRun', params: [stmtRun, fchar]};
        return PrintResource.executeRpc(rpcConfig).$promise;
      },
      getManagedServicesEmailList: function(){
        var rpcConfig = {method: 'GetManagedServicesEmailList', params: []};
        return PrintResource.executeRpc(rpcConfig).$promise;
      },
      sendEmailToApprove: function(dataEmail){
        var rpcConfig = {method: 'SendEmailToApprove', params: [dataEmail]};
        return PrintResource.executeRpc(rpcConfig).$promise;
      },
      savePrintFiles: function(dataFiles){
        var rpcConfig = {method: 'SavePrintFilesBatchPrint', params: [dataFiles]};
        return PrintResource.executeRpc(rpcConfig).$promise;
      },
      cancelPrint: function(printCancelRequest){
        var rpcConfig = {method: 'CancelPrint', params: [printCancelRequest]};
        return PrintResource.executeRpc(rpcConfig).$promise;
      },
      getPrintHistory: function(stmtRun, jobId){
        var rpcConfig = {method: 'GetPrintHistory', params: [stmtRun, jobId]};
        return PrintResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);
